import React from 'react';
import './TopNavBar.css';

export type WaitingTab = 'product' | 'my_combinations' | 'profile';

interface TopNavBarProps {
  activeTab: WaitingTab;
  onTabChange: (tab: WaitingTab) => void;
  productName: string;
}

export const TopNavBar: React.FC<TopNavBarProps> = ({
  activeTab,
  onTabChange,
  productName
}) => {
  return (
    <div className="waiting-top-nav">
      <button 
        className={`waiting-top-nav__item ${activeTab === 'product' ? 'active' : ''}`}
        onClick={() => onTabChange('product')}
      >
        <span className="waiting-top-nav__label">{productName}</span>
        {activeTab === 'product' && <div className="waiting-top-nav__indicator" />}
      </button>
      
      <button 
        className={`waiting-top-nav__item ${activeTab === 'my_combinations' ? 'active' : ''}`}
        onClick={() => onTabChange('my_combinations')}
      >
        <span className="waiting-top-nav__label">Kombinlerim</span>
        {activeTab === 'my_combinations' && <div className="waiting-top-nav__indicator" />}
      </button>
      
      <button 
        className={`waiting-top-nav__item ${activeTab === 'profile' ? 'active' : ''}`}
        onClick={() => onTabChange('profile')}
      >
        <span className="waiting-top-nav__label">Profil</span>
        {activeTab === 'profile' && <div className="waiting-top-nav__indicator" />}
      </button>
    </div>
  );
};

export default TopNavBar;
